module.exports = __webpack_public_path__ + "static/yellow-card-61db1a5f76149976e49d41c20fab39b0.png";